import { motion, Variants } from "framer-motion";
import styled, { css } from "styled-components";
import { SceneItemOffsetPosition } from "../../models/client";

interface SceneMarkerProps {
  imgSrc: string;
  altPos?: boolean;
  size: number;
  position: SceneItemOffsetPosition;
}

const transformPosition = (size: number, pos: SceneItemOffsetPosition) => {
  const x = Math.sqrt(Math.pow(size, 2) / 8);
  const y = Math.sqrt(Math.pow(48, 2) / 8);
  const total = x + y + 8;

  if (pos === "tl") {
    return css`
      transform: translate(${-total}px, ${-total}px);
    `;
  }
  if (pos === "tr") {
    return css`
      transform: translate(${total}px, ${-total}px);
    `;
  }
  if (pos === "bl") {
    return css`
      transform: translate(${-total}px, ${total}px);
    `;
  }
  if (pos === "br") {
    return css`
      transform: translate(${total}px, ${total}px);
    `;
  }
};

const Anchor = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
`;

const Wrapper = styled.div<{
  altPos?: boolean;
  size: number;
  position: SceneItemOffsetPosition;
}>`
  position: relative;
  /* top: 50%;
  left: 50%; */
  border-radius: 50%;
  overflow: hidden;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  ${({ size, position }) => transformPosition(size, position)};
  transform-origin: left bottom;

  /* ${({ altPos }) =>
    !altPos
      ? css`
          left: 50%;
        `
      : css`
          left: -50%;
        `} */
`;

const ImageContainer = styled(motion.div)`
  position: relative;
  width: 100%;
  height: 100%;

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

const variants: Variants = {
  hover: { scale: 1.1 },
};

export const SceneMarkerImage: React.FC<SceneMarkerProps> = ({
  imgSrc,
  altPos,
  size,
  position,
}) => {
  return (
    <Anchor>
      <motion.div variants={variants} transition={{ duration: 0.8 }}>
        <Wrapper altPos={altPos} size={size} position={position}>
          <ImageContainer>
            <img src={imgSrc} alt="" />
          </ImageContainer>
        </Wrapper>
      </motion.div>
    </Anchor>
  );
};
